import ApiService from '../api';
import StorageService from './StorageService';
const Storage = new StorageService('local');

import router from '../router';
const Api = new ApiService();
const SessionStorage = new StorageService('session');
class BaseService {
    static instance = null;

    constructor() {
        this.Api = Api;
        this.Storage = Storage;
        this.SessionStorage = SessionStorage;
        this.baseUrl = '';
    }


    //单例调用,暂不支持构造函数需参数的形式.
    static getInstance(){
        if(this.instance === null){
            this.instance = new this();
        }
        return this.instance;
    }

    /**
     * 请求服务器数据
     * @param url
     * @param param
     * @param method
     * @returns {*|Promise.<TResult>}
     * @constructor
     */
    request(url, param, method='post') {
        let fetchpromise = method === 'post' ? this.Api.post(url, param) : this.Api.get(url, param);
        return fetchpromise.then((response) => {
            if(response.status_code === 200){
                if(response.meta){
                    return response;
                }
                return response.data;
            }else{
                app.$toast.error('请求服务器失败')
            }
        }).catch((e)=>{
            if(e.message && e.message.length < 10){
                app.$toast.error(e.message);
                e.message = '';
            }
            throw e;
        });
    }

    fetchStaticResource(url, data='', method='post'){
        let cacheKey = url + JSON.stringify(data);
        if( this.Storage.has(cacheKey) ){
            return this.createPromise(()=>{
                return this.Storage.get(cacheKey)
            })
        }
        return this.request(url, data, method).then((response)=>{
            if( response !== null ) this.Storage.set(cacheKey, response);
            return response;
        });
    }

    createPromise(callback,time=0) {
        return new Promise(function (resolve) {
            setTimeout(()=>{
                resolve(callback());
            },time);
        });
    }
}

export default BaseService;



// WEBPACK FOOTER //
// ./src/services/BaseService.js